export interface FallbackDetectionResult {
  isAligned: boolean;
  edgeDensity: number;
}

export const detectAlignmentFallback = (
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  video: HTMLVideoElement,
  guidingFrame?: { x: number; y: number; width: number; height: number },
): FallbackDetectionResult => {
  const result: FallbackDetectionResult = {
    isAligned: false,
    edgeDensity: 0,
  };

  if (!video || video.videoWidth === 0 || video.videoHeight === 0) {
    return result;
  }

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  ctx.drawImage(video, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  let edgeCount = 0;
  let totalPixels = 0;

  let marginW = 0;
  let marginH = 0;
  if (guidingFrame) {
    marginW = guidingFrame.width * 0.1;
    marginH = guidingFrame.height * 0.1;
  }

  for (let y = 0; y < canvas.height; y += 2) {
    for (let x = 0; x < canvas.width; x += 2) {
      if (
        guidingFrame &&
        !(
          x >= guidingFrame.x - marginW &&
          x <= guidingFrame.x + guidingFrame.width + marginW &&
          y >= guidingFrame.y - marginH &&
          y <= guidingFrame.y + guidingFrame.height + marginH
        )
      ) {
        continue;
      }

      if (x >= 1 && x < canvas.width - 1 && y >= 1 && y < canvas.height - 1) {
        const idx = (Math.floor(y) * canvas.width + Math.floor(x)) * 4;
        const current = data[idx] ?? 0;
        const right = data[idx + 4] ?? 0;
        const bottom = data[idx + canvas.width * 4] ?? 0;

        const edgeStrengthX = Math.abs(current - right);
        const edgeStrengthY = Math.abs(current - bottom);
        const edgeStrength = Math.max(edgeStrengthX, edgeStrengthY);

        if (edgeStrength > 0) {
          edgeCount++;
        }
        totalPixels++;
      }
    }
  }

  const edgeDensity = edgeCount / (totalPixels || 1);
  result.edgeDensity = edgeDensity;

  console.log(
    `Fallback detection - Edge density: ${edgeDensity.toFixed(3)}, marginW: ${marginW}, marginH: ${marginH}`,
  );

  if (edgeDensity > 0.0005 && edgeDensity < 0.999) {
    result.isAligned = true;
  } else {
    result.isAligned = false;
  }

  return result;
};
